import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { OktaService } from '../../service';

export type RoleMembershipConfig = typeof RoleMembershipConfig._.Config;

export const RoleMembershipConfig = IntegrationConfig.make({
  service: OktaService,
  name: Integration_Handler_Names_Enum.RoleMembership,
  configSchema: z.object({
    roleNamePatternFilter: patternFilterSchema.optional(),
    includeEmptyRoles: z.boolean().optional(),
  }),
});
